module.exports = __webpack_public_path__ + "img/long-term-cache/modules-logos.94e945143fb5f3e4588f998e24c68ad1.jpg";